import { Endpoint } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { FormAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

interface MotivoRejeicao {
  dsObservacaoRejeicao: string;
  dsMotivo: string;
}

@Controller({ fragment: 'reinclusao-rejeicao-feedback' })
export default class ReinclusaoRejeicaoFeedbackController extends BaseController {

  @OnMount({ target: 'form-reinclusao-rejeicao-feedback' })
  public onMountFetchMotivoRejeicao(event: MountEvent): void {
    const api = event.target as unknown as FormAPI;

    const nrSeqBeneficiario = this.context.get('nrSeqBeneficiario') as number;
    const nrSeqReinclusao = this.context.get('nrSeqReinclusao') as number;

    void this.fetchMotivoRescisao(nrSeqBeneficiario, nrSeqReinclusao).then((motivo) => {
      if (motivo) {
        api.setData({ ...motivo });
      }
    });
  }

  private async fetchMotivoRescisao(nrSeqBeneficiario: number, nrSeqReinclusao: number): Promise<MotivoRejeicao | undefined> {
    const { nrSeqContrato } = StipulatorContext.getCurrentContract();

    return (await HttpService.get<MotivoRejeicao>(Endpoint.GET.REINCLUSAO_BENEFICIARIO_MOTIVO_REJEICAO, { nrSeqContrato, nrSeqBeneficiario, nrSeqReinclusao })).body;
  }

}
